import nBossConnection from 'modules/base/service/nBossConnection';
import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import VizsgazoInputFormDataDto from '../dto/VizsgazoInputFormDataDto';
import VizsgazoSubmitDto from '../dto/VizsgazoSubmitDto';

class VizsgazoService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'vizsgazoControl';
	}

	/**
	 * @param {number} examId
	 * @return {Promise<VizsgazoInputFormDataDto>}
	 */
	getInputFormData(examId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getInputFormData`, { examId })
				.then(response => resolve(response.data !== null ? new VizsgazoInputFormDataDto().setup(response.data) : null))
				.catch(reject);
		});
	}

	/**
	 * @param {VizsgazoSubmitDto} input
	 * @return {Promise<EntityValidationResult>}
	 */
	generateExaminee(input) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/generateExaminee`, { input })
				.then(response => resolve(response.data !== null ? new EntityValidationResult().setup(response.data) : null))
				.catch(reject);
		});
	}

	deleteAll(vsorId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/deleteAll`, { vsor_id: vsorId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new VizsgazoService();
